import { getLegacyUrl } from '@/src/general/utils/getLegacyUrl'

import { guideImages, guideTexts, guideUrls } from '../models/guide.constants'
import type { TGuideList } from '../ui/components/GuideLinks/GuideLinks'

export const getGuidesList = (locale: TLocale) =>
  Object.entries(guideUrls[locale]).reduce((acc: TGuideList, [guideType, url]): TGuideList => {
    acc.push({
      text: guideTexts[guideType],
      imageSrc: guideImages[guideType],
      navigateTo: getLegacyUrl(url || ''),
    })
    return acc
  }, [])
